import { useEffect, useRef } from 'react';

const SIX_HOURS_MS = 6 * 60 * 60 * 1000;
const CHECK_INTERVAL_MS = 60 * 1000;
const ACTIVITY_EVENTS: (keyof WindowEventMap)[] = [
  'mousedown',
  'mousemove',
  'keydown',
  'scroll',
  'touchstart',
  'click',
  'wheel',
];

export default function useIdleRefresh(
  idleMs: number = SIX_HOURS_MS,
  onIdle?: () => void,
) {
  const lastActivityRef = useRef<number>(Date.now());
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  useEffect(() => {
    const markActive = () => {
      lastActivityRef.current = Date.now();
    };

    const triggerRefresh = () => {
      if (onIdleRef.current) {
        onIdleRef.current();
      } else {
        window.location.reload();
      }
    };

    const checkIdle = () => {
      if (Date.now() - lastActivityRef.current < idleMs) return;
      window.clearInterval(intervalId);
      triggerRefresh();
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') checkIdle();
    };

    ACTIVITY_EVENTS.forEach((event) =>
      window.addEventListener(event, markActive, { passive: true }),
    );
    document.addEventListener('visibilitychange', onVisibilityChange);
    const intervalId = window.setInterval(checkIdle, CHECK_INTERVAL_MS);

    return () => {
      ACTIVITY_EVENTS.forEach((event) =>
        window.removeEventListener(event, markActive),
      );
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.clearInterval(intervalId);
    };
  }, [idleMs]);
}
